import { Link } from 'react-router-dom';
import logo from "../../../studentassets/logo.png";
import { useEffect, useState } from 'react';
import { MdMenu } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { FaFacebookF } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";

export default function Header() {

    const [isSticky, setIsSticky] = useState(false);
    const [open, setOpen] = useState(false);
    const authToken = localStorage.getItem("authToken");

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            {/* Header Section */}
            {/* <header className="header-one header--sticky"> */}
            <header className={`header-one ${isSticky ? "header--sticky" : ""}`} style={{ background: "black" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="header-main-wrapper">
                                <Link to="/" className="logo" Style= "font-size: 30px; font-weight: 600; color: #666cff;">
                                    <img src={logo} alt="logo" width="80" />
                                    cuzysolve
                                </Link>

                                <div className="nav-area-main d-xl-block d-lg-block d-md-none d-sm-none d-none">
                                    <nav>
                                        <ul>
                                            <li><Link className="links-main" to="/">Home</Link></li>
                                            <li> <Link className="links-main" to="/pricing">Pricing</Link></li>
                                            <li><Link className="links-main" to="/about">About</Link></li>
                                            <li><Link className="links-main" to="/faq">FAQ</Link></li>
                                            <li><Link className="links-main" to="/blog">Blog</Link></li>
                                            <li><Link className="links-main" to="/feature">Feature</Link></li>
                                            <li><Link className="links-main" to="/contact">Contact</Link></li>
                                        </ul>
                                    </nav>
                                </div>

                                <div className="button-area">
                                    {authToken ?
                                        <Link to="/user/dashboard" className="rts-btn btn-blur">Dashboard</Link>
                                        :
                                        <Link to="/signin" className="rts-btn btn-blur">Sign in</Link >
                                    }
                                </div>

                                <button className="menu-btn d-xl-none d-lg-none d-md-block d-sm-block" id="menu-btn" onClick={() => setOpen(true)}><MdMenu className='menubtn' /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>




            {/* Mobile Section */}
            <div id="anywhere-home" className={open ? "active" : ""} onClick={() => setOpen(false)}></div>

            <div id="side-bar" className={`side-bar header-two ${open ? "active" : ""}`}>
                <button className="close-icon-menu" onClick={() => setOpen(false)}>
                    <IoMdClose />
                </button>

                <div className="mobile-menu-main">
                    <nav className="nav-main mainmenu-nav mt--30">
                        <ul className="mainmenu metismenu" id="mobile-menu-active">
                            <li className="parent">
                                <Link to="/" className="main">Home</Link>
                            </li>
                            <li className="parent">
                                <Link to="/pricing" className="main">Pricing</Link>
                            </li>

                            <li className="parent">
                                <Link to="/about" className="main">About</Link>
                            </li>

                            <li className="parent">
                                <Link to="/faq" className="main">FAQ</Link>
                            </li>

                            <li className="parent">
                                <Link to="/blog" className="main">Blog</Link>
                            </li>

                            <li className="parent">
                                <Link to="/feature" className="main">Feature</Link>
                            </li>

                            <li className="parent">
                                <Link to="/contact" className="main">Contact</Link>
                            </li>
                        </ul>
                    </nav>

                    <div className="button-area">

                        {authToken ?
                            <Link to="/user/dashboard" className="rts-btn btn-primary w-100 text-center text-white">Dashboard</Link>
                            :
                            <Link to="/signin" className="rts-btn btn-primary w-100 text-center text-white">Sign in</Link >
                        }

                         {/* <Link to="/signin" className="rts-btn btn-primary w-100 text-center text-white">Sign in</Link> */}
                    </div>

                    <div className="rts-social-style-one pl--20 mt--100">
                        <ul>
                            <li>
                                <Link to="#">
                                    <FaFacebookF className='text-white' />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <FaTwitter className='text-white' />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <BsWhatsapp className='text-white' />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <FaLinkedinIn className='text-white' />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>


        </>
    )
}
